import { RoutesPaths } from '@space-shell/core/router'
import { useMembershipStore } from '@space-shell/core/store'
import URLHelper from '@space-shell/modules/sales/presentation/helpers/url/url-helper'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import type { UseSalesPageType } from './use-sales-page.types'

const useSalesPage = ({ product }: UseSalesPageType) => {
  const { membershipSlug } = useMembershipStore()
  const { i18n } = useTranslation()

  if (!product.affiliationCode) return null
  if (!product.clubSalesPage?.pageOnline) return null

  const queryParams = URLHelper.productPageParams(product.productHotLink)

  return generatePath(`${RoutesPaths.HOME}${RoutesPaths.SALES}`, {
    lang: i18n.language.toLowerCase(),
    membership: membershipSlug,
    slug: product.clubSalesPage?.slug,
    referenceCode: product.affiliationCode
  }).concat(queryParams)
}

export default useSalesPage
